import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Convert a stored file path (e.g. /api/files/...) to an absolute URL
export const fileUrl = (u) => (!u ? "" : /^https?:/.test(u) ? u : `${BASE}${u}`);

export const api = {
  register: (data) => client.post("/auth/register", data).then((r) => r.data),
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  getContent: () => client.get("/content").then((r) => r.data),
  updateContent: (data) => client.put("/content", data).then((r) => r.data),
  listCourses: () => client.get("/courses").then((r) => r.data),
  getCourse: (id) => client.get(`/courses/${id}`).then((r) => r.data),
  createCourse: (data) => client.post("/courses", data).then((r) => r.data),
  updateCourse: (id, data) => client.put(`/courses/${id}`, data).then((r) => r.data),
  deleteCourse: (id) => client.delete(`/courses/${id}`).then((r) => r.data),
  listGrants: () => client.get("/grants").then((r) => r.data),
  addGrant: (data) => client.post("/grants", data).then((r) => r.data),
  delGrant: (data) => client.delete("/grants", { data }).then((r) => r.data),
  myAccess: () => client.get("/my/access").then((r) => r.data),
  myProgress: () => client.get("/my/progress").then((r) => r.data),
  setProgress: (data) => client.post("/my/progress", data).then((r) => r.data),
  listUsers: () => client.get("/users").then((r) => r.data),

  // uploads
  uploadImage: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const r = await client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data;
  },
  uploadVideo: async (file, onProgress) => {
    const chunkSize = 4 * 1024 * 1024; // 4MB
    const total = Math.ceil(file.size / chunkSize) || 1;
    const uploadId = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now());
    for (let i = 0; i < total; i++) {
      const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);
      const fd = new FormData();
      fd.append("uploadId", uploadId);
      fd.append("index", i);
      fd.append("total", total);
      fd.append("filename", file.name);
      fd.append("file", blob);
      await client.post("/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onProgress && onProgress(Math.round(((i + 1) / total) * 100));
    }
    const fd2 = new FormData();
    fd2.append("uploadId", uploadId);
    fd2.append("total", total);
    fd2.append("filename", file.name);
    const r = await client.post("/upload/complete", fd2, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data;
  },
};

export default api;
